module.exports = __webpack_public_path__ + "img/1450808051.99fc5abc.jpg";